/**
 * Which on-screen keyboard a text field opens, worked out from its validation rules, so every
 * phone, email and number field gets the right one without each schema having to say so.
 *
 * Only `inputmode` and its companions are set. The field stays type="text": the value, the
 * validation and what is submitted are unchanged, and none of the type="email"/"number" side
 * effects come along (browser error popups, spinner arrows, scroll-wheel changes, lost leading
 * zeros). A schema's own `attrs` still win over these hints.
 *
 * The number pad only goes on rules that accept digits and nothing else; anything that can hold
 * letters (postal code, driver's licence, names) keeps the full keyboard. A rate (6.99) gets the
 * pad with a decimal key, which is "," on a phone set to French.
 */

const EMAIL_RULES = ['email', 'emailConfirmation'];
const PHONE_RULES = ['phone', 'canadianPhone', 'usPhone'];
const DIGITS_ONLY_RULES = ['numeric', 'ssn', 'sin', 'bankRoutingNumber', 'bankAccountNumber', 'carYear'];
const DECIMAL_RULES = ['rate'];

function ruleNames(rules) {
    return String(rules ?? '')
        .split('|')
        .map(rule => rule.split(':')[0].trim())
        .filter(Boolean);
}

export function keyboardHintsFor(rules) {
    const names = ruleNames(rules);

    if (names.some(rule => EMAIL_RULES.includes(rule))) {
        // no auto-capitalised first letter or "corrected" domain
        return { inputmode: 'email', autocapitalize: 'none', autocorrect: 'off', spellcheck: 'false' };
    }
    if (names.some(rule => PHONE_RULES.includes(rule))) {
        return { inputmode: 'tel' };
    }
    if (names.some(rule => DIGITS_ONLY_RULES.includes(rule))) {
        return { inputmode: 'numeric' };
    }
    if (names.some(rule => DECIMAL_RULES.includes(rule))) {
        return { inputmode: 'decimal' };
    }
    return {};
}
